import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber programar?',
  a: 'No, el libro está escrito para padres con cero experiencia técnica. Todo se explica con analogías sencillas y guías visuales.'
}, {
  q: '¿Tengo que comprar software caro?',
  a: 'No, todas las herramientas recomendadas son de uso gratuito profesional. No necesitas suscripciones mensuales.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Siguiendo la guía, tu hijo puede tener su primer objeto programado y funcionando en la primera tarde de trabajo.'
}, {
  q: '¿Sirve para cualquier videojuego?',
  a: 'Nos enfocamos en las plataformas líderes donde los niños ya están: Roblox, Scratch y Minecraft, ya que ofrecen las mejores herramientas de creación.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-16 bg-[#0a0e1a]" data-id="element-20">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-21">
        <h2 className="text-3xl font-bold text-center text-white mb-8" data-id="element-22">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-800 rounded-lg bg-[#111827] overflow-hidden transition-colors hover:border-gray-700" data-id="element-24">
              <button className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-25">
                <span className="font-semibold text-white text-lg" data-id="element-26">
                  {faq.q}
                </span>
                {openIndex === idx ? <ChevronUp className="h-5 w-5 text-[#00d4aa]" data-id="element-27" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-28" />}
              </button>

              {openIndex === idx && <div className="px-6 pb-4 text-gray-400 animate-in slide-in-from-top-2 duration-200" data-id="element-29">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}